// extracted by mini-css-extract-plugin
export default {"container":"UsuarioNovo_container__lzNgf"};